import { render, staticRenderFns } from "./presentation-external-player-controls.vue?vue&type=template&id=33d6e93f&scoped=true&"
import script from "./presentation-external-player-controls.vue?vue&type=script&lang=js&"
export * from "./presentation-external-player-controls.vue?vue&type=script&lang=js&"
import style0 from "./presentation-external-player-controls.vue?vue&type=style&index=0&id=33d6e93f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d6e93f",
  null
  
)

export default component.exports